import { CheckCircle2, Sparkles, XCircle } from "lucide-react";

const YES = [
  "Drafting boilerplate code and tests",
  "Searching documentation faster",
  "Sanity-checking SQL and data shapes",
  "Cleaning up notes into clear docs",
];

const NO = [
  "Architecture and trade-off decisions",
  "Touching production without review",
  "Anything we can't explain in plain English",
  "Replacing the human in the room",
];

export function AIStatement() {
  return (
    <section className="ai-statement" id="ai">
      <div className="container">
        <div className="ai-band reveal">
          <span className="ai-band-tag">On AI</span>
          <div className="ai-band-grid">
            <div className="ai-band-mark" aria-hidden>
              <div className="ai-bloom" />
              <div className="ai-mark">
                <Sparkles size={44} />
              </div>
            </div>

            <div className="ai-band-body">
              <p className="ai-statement-text">
                We use AI to <em>move faster.</em>
                <br />
                A human is always at the wheel.
              </p>
              <p className="ai-statement-small">
                Every solution we deliver is reviewed, guided, and validated by
                an experienced developer. AI is a tool in the box — it doesn't
                decide what gets shipped, and it doesn't write code that lands
                in your business without a human reading every line.
              </p>

              <div className="ai-columns">
                <div className="ai-col ai-col-yes">
                  <div className="ai-col-head">
                    <CheckCircle2 size={18} />
                    Where we use it
                  </div>
                  <ul>
                    {YES.map((i) => (
                      <li key={i}>{i}</li>
                    ))}
                  </ul>
                </div>
                <div className="ai-col ai-col-no">
                  <div className="ai-col-head">
                    <XCircle size={18} />
                    Where we don't
                  </div>
                  <ul>
                    {NO.map((i) => (
                      <li key={i}>{i}</li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
